(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name tracking.controller:FilghtFilterCtrl
     *
     * @description
     *
     */
    angular
        .module('tracking')
        .controller('FilghtFilterCtrl', FilghtFilterCtrl);

    function FilghtFilterCtrl($uibModalInstance,TrackingHelper,TrackingModel) {
        var vm = this;
        vm.model = {
            selectedRegNumbers : [],
            allAircrafts : []
        };

        TrackingModel.aircraftList.subscribe(function (aircrafts) {
            if(!!aircrafts){
            	for(var i=0;i<aircrafts.length;i++){
                	if(aircrafts[i].status==='ACT'){
                		vm.model.allAircrafts.push(aircrafts[i]);
                	}
                }
            }
        });

        TrackingModel.regNumberFilterCriteria.subscribe(function (flightRegNumbers) {
            vm.model.selectedRegNumbers = flightRegNumbers;
        });

        vm.onClose = function () {
            $uibModalInstance.close();
        };

        vm.onFilterClick = function () {
            if(vm.model.selectedRegNumbers.length > 0){
                TrackingModel.setRegNumberFilterCriteria(vm.model.selectedRegNumbers);
            }else{
                TrackingModel.setRegNumberFilterCriteria([]);
            }
            $uibModalInstance.close();
        };

    }
}());
